import {
    SwiggyInstrumentsPaymentMethodData,
    SwiggyInstrumentsData,
    WalletData,
    WalletPaymentMethodData,
} from "@payment-ui/interfaces";

import {
    getPaymentMethodPromoMsg,
    getPaymentMethodDisableMsg,
    getPaymentMethodDisabledMsg,
} from "@payment-ui/helpers/Payment";
import { TEXTS, ACCESSIBILITY_TEXTS } from "@payment-ui/constants/index";
import { format, concatStrings } from "@swiggy-private/core-ui";

export const getPaymentAriaLabel = ({
    paymentMethodData,
    paymentData,
    balance,
    showLessBalanceText,
    isSelected,
}: {
    paymentMethodData: SwiggyInstrumentsPaymentMethodData | WalletPaymentMethodData;
    paymentData: SwiggyInstrumentsData | WalletData;
    balance: string | number;
    showLessBalanceText: boolean;
    isSelected: boolean;
}): string => {
    const selectedText = isSelected ? ACCESSIBILITY_TEXTS.SELECTED : "";
    const promoMsg = getPaymentMethodPromoMsg(paymentMethodData);
    const remainingBalanceText = format(ACCESSIBILITY_TEXTS.REMAINING_BALANCE, String(balance));
    const lowBalanceText = showLessBalanceText
        ? format(TEXTS.LOW_BALANCE_DETAIL, String(paymentData.additionalBalanceRequired))
        : "";
    return concatStrings(paymentMethodData.displayName, selectedText, remainingBalanceText, promoMsg, lowBalanceText)();
};

export const getPaymentLinkedAriaLabel = (
    paymentMethodData: SwiggyInstrumentsPaymentMethodData | WalletPaymentMethodData,
): string => {
    const promoMsg = getPaymentMethodPromoMsg(paymentMethodData);
    const linkedText = ACCESSIBILITY_TEXTS.NOT_LINKED;
    return concatStrings(paymentMethodData.displayName, promoMsg, linkedText)();
};

export const getPaymentMethodDisableAriaLabel = (
    paymentMethodData: SwiggyInstrumentsPaymentMethodData | WalletPaymentMethodData,
): string => {
    const disableMsg = getPaymentMethodDisabledMsg(paymentMethodData);
    return concatStrings(paymentMethodData.displayName, disableMsg)();
};

export const getPaymentDisableAriaLabel = (
    paymentMethodData: SwiggyInstrumentsPaymentMethodData | WalletPaymentMethodData,
): string => {
    const disableMsg = getPaymentMethodDisableMsg(paymentMethodData);
    return concatStrings(paymentMethodData.displayName, disableMsg)();
};
